import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback, useEffect, } from "react";
import { depositService } from "@/api/services/deposit.service";
const DEFAULT_DEPOSIT_PERCENTAGE = 30;
const DepositContext = createContext(undefined);
export const DepositProvider = ({ children }) => {
    const [deposit, setDeposit] = useState(null);
    const [loading, setLoading] = useState(true);
    const refetch = useCallback(async () => {
        setLoading(true);
        try {
            const res = await depositService.getDeposit();
            setDeposit(res.data.deposit ?? null);
        }
        catch {
            setDeposit(null);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        refetch();
    }, [refetch]);
    const updateDeposit = useCallback(async (amount) => {
        await depositService.createDeposit(amount);
        await refetch();
    }, [refetch]);
    const defaultDepositPercentage = deposit?.amount != null ? deposit.amount : DEFAULT_DEPOSIT_PERCENTAGE;
    const value = {
        deposit,
        loading,
        defaultDepositPercentage,
        refetch,
        updateDeposit,
    };
    return (_jsx(DepositContext.Provider, { value: value, children: children }));
};
export const useDeposit = () => {
    const context = useContext(DepositContext);
    if (context === undefined) {
        throw new Error("useDeposit must be used within a DepositProvider");
    }
    return context;
};
